import { render, staticRenderFns } from "./TBreadcrumbs.vue?vue&type=template&id=5a10cc79"
import script from "./TBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./TBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./TBreadcrumbs.vue?vue&type=style&index=0&id=5a10cc79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports